import http from "../request";
import store from "@/store";

export interface Template {
  id: number;
  temple_id: number;
  order: number;
  type: number;
  oa_type: number;
  is_oa: number;
  name: string;
  detail: string;
  flow: string;
  icon: string;
  other_config?: string;
  visible_ids?: string;
  admin_ids?: string;
  reserve_config?: string;
  original_admin_ids?: string;
  original_visible_ids?: string;
  check_user_id?: string;
  extra_temp_id?: string;
  create_time: string;
  update_time: string;
}

export interface TemplateApi {
  getVehicleTemplate: () => Promise<Template>;
}

const templateApi: TemplateApi = {
  getVehicleTemplate() {
    const key = store.getters.key;
    return http.get<Template>(`/weixin/car-apply/get-temp?visitKey=${key}`).then((res) => res.data);
  },
};

export default templateApi;
